import React from 'react';
import { StyleSheet, View } from 'react-native';
import { ButtonBag, theme } from '@sweetgreen/garnish';

import { useCart } from '@order/hooks';
import { useLocalizationContext } from '@order/Localization';

import { useOpenBag } from '../../Bag.hooks';

export const BagAccessButton = () => {
  const { t } = useLocalizationContext();
  const { lineItemsCount } = useCart();
  const openBag = useOpenBag({ shouldUpdateCart: true });

  return (
    <View style={styles.bagAccess}>
      <ButtonBag
        testID="bag.access"
        size="large"
        bagCount={lineItemsCount}
        onPress={openBag}
      >
        {t('bag.view-bag')}
      </ButtonBag>
    </View>
  );
};

const styles = StyleSheet.create({
  bagAccess: {
    position: 'absolute',
    right: theme.spacing.medium,
    bottom: theme.spacing.medium,
  },
});
